import { FC } from "react";
import { MDSSkeletonProps } from "./skeleton.types";
import { StyledSkeleton } from "./skeleton.style";

export const MDSSkeleton: FC<MDSSkeletonProps> = ({
  height = 15,
  width = "100%",
  count = 1,
  delay = 0,
  disableAnimation = false,
  startColor,
  middleColor,
  endColor,
  ...props
}) => {
  return (
    <>
      {Array.from({ length: count }, (_, i) => {
        const rowDelay = delay + i * 100; // Stagger animations for multiple rows
        return (
          <StyledSkeleton
            {...props}
            key={i}
            $height={height}
            $width={width}
            $animationDelay={rowDelay}
            $disableAnimation={disableAnimation}
            $startColor={startColor}
            $middleColor={middleColor}
            $endColor={endColor}
          />
        );
      })}
    </>
  );
};
